export default [
  {
    path: '/reset/password',
    name: 'resetPassword',
    component: () => import('@/views/verify/reset-password'),
  },
  {
    path: '/reset/verify',
    name: 'verify',
    component: () => import('@/views/verify/verify'),
  },
]
